export const SOURCE_DIVIDER = "-source-";
export const DIRECT_LIST = ["direct", `direct${SOURCE_DIVIDER}(direct)`];